module.exports = __webpack_public_path__ + "img/idcard_back.9ee24d76.png";